export function isLinkDomainUrl(href: string): boolean {
  const url = new URL(href);
  return url.hostname.startsWith('link') ||
    url.hostname.startsWith('share') ||
    href.includes('?share');
}
